import { render } from "./PageNoAccess.vue?vue&type=template&id=7bf4dede&scoped=true"
const script = {}

import "./PageNoAccess.vue?vue&type=style&index=0&id=7bf4dede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf4dede"]])

export default __exports__